import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { map } from 'lodash/fp';

import { useTracker } from '../../../../hooks';
import { sendPageLog } from '../../../log/services';
import { RouteWithSubroutes } from '../../components';
import routes from '../../routes';
import PrivateRoute from '../PrivateRoute';

const Routes = ({ location, history }) => {
  const info = useSelector((state) => state.user.info);

  useEffect(() => {
    const unlisten = history.listen(({ pathname, state = {} }) => {
      if (info.id) {
        sendPageLog({
          id: info.user_id,
          role: info.role,
          grade: info.grade || 0,
          client_time: new Date().getTime(),
          app_version: navigator.appVersion,
          os_version: null,
          ip: null,
          language: info.language || navigator.language,
          country: info.country_code || navigator.language,
          device: 'web.event',
          cur_page: pathname || '',
          prev_page: state.from || '',
        });
      }
    });

    return unlisten;
  }, [history, info]);

  useTracker(location);

  return (
    <Switch>
      {map(({ isPrivate, ...otherProps }) => (
        isPrivate
          ? <PrivateRoute {...otherProps} />
          : <RouteWithSubroutes {...otherProps} />
      ), routes)}
      <Redirect to="/not-found" />
    </Switch>
  );
};

Routes.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

export default withRouter(Routes);
